import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuthProvider, useDataProvider, Loader } from '@cloudpremise/portal_core';

// @mui material components
import Grid from "@mui/material/Grid";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import Icon from "@mui/material/Icon";
import { ProcessQueue } from "../types";

// Material Dashboard 2 PRO React TS components
import MDBox from "@cloudpremise/portal_core/src/themes/mui/components/MDBox";
import MDTypography from "@cloudpremise/portal_core/src/themes/mui/components/MDTypography";
import MDButton from "@cloudpremise/portal_core/src/themes/mui/components/MDButton";
import CircularProgress from '@mui/material/CircularProgress';
import Box from '@mui/material/Box';
import Alert from '@mui/material/Alert';
import Stack from '@mui/material/Stack';

// Material Dashboard 2 PRO React TS examples components
import DashboardLayout from "@cloudpremise/portal_core/src/themes/mui/examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "@cloudpremise/portal_core/src/themes/mui/examples/Navbars/DashboardNavbar";
import ComplexProjectCard from "@cloudpremise/portal_core/src/themes/mui/examples/Cards/ProjectCards/ComplexProjectCard";

import Config from "../../../../Config";
const cdnUrl = Config.getCdnUrl();

// Images
const team1 = cdnUrl + "/assets/images/team-1.jpg";
const team2 = cdnUrl + "/assets/images/team-2.jpg";
const team3 = cdnUrl + "/assets/images/team-3.jpg";
const team4 = cdnUrl + "/assets/images/team-4.jpg";
const team5 = cdnUrl + "/assets/images/team-5.jpg";
const logoReactforce = cdnUrl + "/assets/images/logo_short.png";

const Home = (props) => {
    const [ authorized, authType ] = useAuthProvider();

    // ComplexProjectCard dropdown menu state
    const [slackBotMenu, setSlackBotMenu] = useState(null);

    // TeamProfileCard dropdown menu handlers
    const openSlackBotMenu = (event: any) => setSlackBotMenu(event.currentTarget);
    const closeSlackBotMenu = () => setSlackBotMenu(null);

    const defaultState = {
        loading: false,
        loadingMore: false,
        response: null,
        RF_LIMIT: 20,
        RF_OFFSET: null,
        itemModal: false,
        item: null,
        errorMessage: null
    };

    const [state, setState] = React.useReducer((state: any, newState: Partial<any>) => ({
        ...state,
        ...newState
    }), defaultState);

    const navigate = useNavigate();

    const queue: ProcessQueue = {
        sObjectTypeName: "ProcessQueue__c",
        url: "/v1/bpm/queue"
    }
    const [loading, data, adapterState, setAdapterState] = useDataProvider(queue, {
        "RF_LIMIT": state.RF_LIMIT,
        "RF_OFFSET": state.RF_OFFSET,
        "provider": "apexadapter"
    }, false, (data) => {
        // console.log(data);
        // if(state.response && state.response.nextKey){
        //     data = Object.assign(state.response, data);
        // }
        let errorMessage = null;
        if(data.hasOwnProperty("error") && data.error !== null){
            errorMessage = data.error;
        }
        setState({
            response: data,
            errorMessage: errorMessage
        });
    });

    React.useEffect(() => {
        if(authorized && (authType !== "link" && authType !== "microsoft" && authType !== "google" && authType !== "github" && authType !== "facebook")){
            return navigate("/auth-not-supported", { replace: true });
        }
        if(state.linkExpired){
            window.history.replaceState(null, document.title, props.basename+"/auth/login-link"+window.location.search);
            return navigate("/auth/login-link", { replace: true });
        }
    });

    // Dropdown menu template for the ComplexProjectCard
    const renderMenu = (state: any, close: any) => (
        <Menu
            anchorEl={state}
            anchorOrigin={{ vertical: "top", horizontal: "left" }}
            transformOrigin={{ vertical: "top", horizontal: "right" }}
            open={Boolean(state)}
            onClose={close}
            keepMounted
        >
            <MenuItem onClick={close}>Action</MenuItem>
            <MenuItem onClick={close}>Another action</MenuItem>
            <MenuItem onClick={close}>Something else here</MenuItem>
        </Menu>
    );

    const renderProjects = () => {
        const { response } = state;
        let result = [];
        if(response && Array.isArray(response.result)){
            result = response.result;
        }
        return result.map((item) => {
            return (
                <Grid item xs={12} md={6} lg={4}>
                    <MDBox mb={1.5} mt={1.5}>
                        <ComplexProjectCard
                            image={logoReactforce}
                            title={item.processQueueName}
                            description={item.processQueueDescription}
                            members={[team1, team2, team3, team4, team5]}
                            url={"/bpm/queues/"+item.processQueueId}
                            dropdown={{
                                action: openSlackBotMenu,
                                menu: renderMenu(slackBotMenu, closeSlackBotMenu),
                            }}
                        />
                    </MDBox>
                </Grid>
            )
        });
    }

    return (
        <DashboardLayout>
            <DashboardNavbar />
            <MDBox py={3}>
                <Grid container alignItems="center">
                    <Grid item xs={12} md={7}>
                        <MDBox mb={1}>
                            <MDTypography variant="h5">My Queues</MDTypography>
                        </MDBox>
                    </Grid>
                    {/* <Grid item xs={12} md={5} sx={{ textAlign: "right" }}>
                        <MDButton variant="gradient" color="info">
                            <Icon>add</Icon>&nbsp; Add New
                        </MDButton>
                    </Grid> */}
                </Grid>
                <MDBox mt={5}>
                    {
                        loading ?
                            <Loader p={2} color="info" />
                        :
                            state.errorMessage !== null ?
                                <Stack p={2}>
                                    <Alert severity="error">{state.errorMessage}</Alert>
                                </Stack>
                            :
                            <Grid container spacing={3}>
                                {renderProjects()}
                            </Grid>
                    }
                    
                </MDBox>
            </MDBox>
        </DashboardLayout>
    );
};

export default Home;